export default __webpack_public_path__ + "static/media/ios_step2.9a02c3aa.png";